<template>
    <img :src="VerifiedIcon" :height="iconSize" :width="iconSize" :class="`${appendedInnerClass} select-none`" alt="verified" :draggable="false"/>
    <!-- <svg aria-label="Verified" fill="rgb(0, 149, 246)" :height="iconSize" :width="iconSize" role="img" viewBox="0 0 40 40"><title>Verified</title><path d="M19.998 3.094 14.638 0l-2.972 5.15H5.432v6.354L0 14.64 3.094 20 0 25.359l5.432 3.137v5.905h5.975L14.638 40l5.36-3.094L25.358 40l3.232-5.6h6.162v-6.01L40 25.359 36.905 20 40 14.641l-5.248-3.03v-6.46h-6.419L25.358 0l-5.36 3.094Zm7.415 11.225 2.254 2.287-11.43 11.5-6.835-6.93 2.244-2.258 4.587 4.581 9.18-9.18Z" fill-rule="evenodd"></path></svg> -->
</template>
<script setup>
import VerifiedIcon from "@/assets/icons/9224364_verified_check_mark_verification_badge_icon.svg";
import { ref } from "vue";

const props = defineProps({
  size: String,
  appendedInnerClass: String
});
const iconSize = ref(18);

if(props?.size == 'sm'){
  iconSize.value = 16;
}

</script>